<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-card flat>
        <!-- انتخاب جهت اسلایدر -->
        <!-- <v-select
          v-model="sliderSettings.orientation"
          :items="[
            { text: 'افقی (Horizontal)', value: 'horizontal' },
            { text: 'عمودی (Vertical)', value: 'vertical' }
          ]"
          label="جهت نمایش اسلایدر"
          outlined
          dense
        ></v-select> -->

        <!-- تیک پخش خودکار در افزودن ویدئو -->
        <!-- <v-checkbox
          v-model="videoSettings.autoplay"
          label="پخش خودکار ویدئو (Autoplay)"
          hide-details
          class="mb-4"
        ></v-checkbox> -->

        <v-expansion-panels
          :class="singleGallery ? '' : 'pa-2'"
          :flat="singleGallery"
          :mandatory="singleGallery"
          focusable
        >
          <v-expansion-panel
            v-for="(salon, index) in gallery"
            :key="index"
            class="mt-2 rounded-lg"
          >
            <v-expansion-panel-header v-if="!singleGallery">
              <div v-if="index !== editGalleryName">{{ salon.name }}</div>
              <div v-if="index === editGalleryName" class="rowinfo">
                <div class="contnetinfo">
                  <v-text-field
                    v-if="index === editGalleryName"
                    v-model="salon.name"
                    :label="$t('gallery_name')"
                    append-icon="check"
                    class="my-2"
                    dense
                    hide-details
                    outlined
                    @click.stop
                    @click:append.stop="editGalleryName = -1"
                  />
                </div>
                <help-info
                  :element-name="`${serviceName}-${componentName}-data-editGalleryName`"
                  :help-data="helpData"
                  :label="$t('gallery_name')"
                  :service-name="serviceName"
                  class="buttoninfo"
                />
              </div>

              <v-spacer />

              <div v-if="index !== editGalleryName" class="rowinfo justify-end">
                <v-btn
                  v-if="index !== editGalleryName"
                  icon
                  max-width="36"
                  @click.stop="editGalleryName = index"
                >
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
                <help-info
                  v-show="index === -1"
                  :element-name="`${serviceName}-${componentName}-editGalleryName`"
                  :help-data="helpData"
                  :label="$t('choice_gallery')"
                  :service-name="serviceName"
                  class="buttoninfo"
                />
              </div>

              <!-- v-if="gallery.length > 1" -->
              <v-btn icon max-width="36" @click="deleteGallery(index)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-expansion-panel-header>

            <v-expansion-panel-content class="mt-4">
              <div class="rowinfo">
                <div class="d-flex align-start contentinfo">
                  <v-btn
                    block
                    color="success"
                    outlined
                    @click="
                      () => {
                        manualDialog = true;
                        selectedSalon = { ...salon };
                      }
                    "
                  >
                    {{ $t("choice_video") }}
                    <v-icon right>mdi-video-plus-outline</v-icon>
                  </v-btn>
                </div>
                <help-info
                  :element-name="`${serviceName}-${componentName}-data-selectvideo`"
                  :help-data="helpData"
                  :label="$t('choice_video')"
                  :service-name="serviceName"
                  class="buttoninfo"
                />
              </div>

              <v-row v-if="rerender" no-gutters>
                <v-col
                  v-for="(video, index) in salon.images"
                  :key="video.id || index"
                  class="align-center pa-2 position-relative"
                  cols="12"
                >
                  <div class="rowinfo">
                    <div class="contentinfo">
                      <div class="border rounded" @click="selectVideo(video)">
                        <template v-if="video.url || video.file_link">
                          <v-btn
                            class="float-end zindex-5 p-0 ms-auto my-auto"
                            icon
                            small
                            @click.stop="
                              deleteSelectedImage(salon, video, index)
                            "
                          >
                            <v-icon style="color: #999 !important"
                              >mdi-delete
                            </v-icon>
                          </v-btn>

                          <v-card
                            class="pa-2 text-center justify-space-between d-flex align-center"
                            flat
                          >
                            <v-btn
                              :disabled="index === 0"
                              icon
                              @click.stop="moveUp(salon, video)"
                            >
                              <v-icon>mdi-chevron-up</v-icon>
                            </v-btn>

                            <!-- <iframe :src="video.url || video.file_link"/> -->
                            <video-iframe :key-id="index" :video="video" />

                            <v-btn
                              :disabled="index >= salon.images.length - 1"
                              icon
                              @click.stop="moveDown(salon, video)"
                            >
                              <v-icon>mdi-chevron-down</v-icon>
                            </v-btn>
                          </v-card>
                        </template>

                        <template v-else>
                          <v-text-field
                            v-model="setUrl"
                            :label="$t('url_video')"
                            class="ma-2"
                            dense
                            hide-details
                            outlined
                            @click.stop
                            @keydown.enter="
                              () =>
                                checkVideoUrl ? addToGallery(video) : false
                            "
                          >
                            <template v-slot:append-outer>
                              <v-btn
                                :disabled="!checkVideoUrl"
                                color="success"
                                icon
                                small
                                @click.stop="addToGallery(video)"
                              >
                                <v-icon>mdi-plus</v-icon>
                              </v-btn>

                              <v-btn
                                icon
                                small
                                @click.stop="
                                  deleteSelectedImage(salon, video, index)
                                "
                              >
                                <v-icon style="color: #999 !important"
                                  >mdi-delete
                                </v-icon>
                              </v-btn>
                            </template>
                          </v-text-field>
                        </template>
                      </div>
                    </div>
                    <help-info
                      v-show="index === -1"
                      :element-name="`${serviceName}-${componentName}-data-selectedvideo`"
                      :help-data="helpData"
                      :label="$t('selected_video')"
                      :service-name="serviceName"
                      class="buttoninfo"
                    />
                  </div>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <custom-popup
          id="gallery"
          v-model="manualDialog"
          :cons="{ title: $t('add_video') }"
          max-width="960"
          reloadable
        >
          <video-uploader
            v-model="selectedSalon"
            :single-gallery="singleGallery"
            @close="manualDialog = false"
          />
        </custom-popup>

        <custom-popup
          id="edit-gallery"
          v-model="editDialog"
          :cons="{ title: $t('edit_video') }"
          max-width="500"
        >
          <v-card class="p-8">
            <div class="rowinfo">
              <v-text-field
                v-model="selectedVideo.title"
                :label="$t('title')"
                class="my-2 contnetinfo"
                dense
                hide-details
                outlined
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-data-title`"
                :help-data="helpData"
                :label="$t('title')"
                :service-name="serviceName"
                class="buttoninfo"
              />
            </div>
            <div class="rowinfo" style="width: 100%" v-if="[                      
                      'qr.video',
                      'qr.name.id.editVideo',
                      'qr.name.editVideo',
                      'qr.cardVisit',
                      'qr.create.cardVisitProModel',
                      'qr.cardVisitPro',
                      'qr.name.id.edit.pro',
                      'qr.name.edit.pro',
                      'qr.name.edit',
                      'qr.name.edit.pro',
                      'qr.name.id.edit',
                        ].includes($route.name)">
                      <pic-selector style="width: 100%"
                        :edit-name="false"
                        :field.sync="selectedVideo.cover_url"
                        one-pic
                        single
                      />
                      <help-info
                        :element-name="`${serviceName}-${componentName}-selectedImage-url`"
                        :service-name="serviceName"
                        :help-data="helpData"
                        class="buttoninfo"
                        label="پیش نمایش"
                      />
              </div>

            <div class="rowinfo">
              <v-text-field
                v-model="selectedVideo.link"
                :label="$t('linl_video')"
                :rules="[addVideoRule.link]"
                class="my-2 contnetinfo"
                dense
                hide-details
                outlined
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-selectedVideo-link`"
                :help-data="helpData"
                :label="$t('linl_video')"
                :service-name="serviceName"
                class="buttoninfo"
              />
            </div>
            <div class="rowinfo">
              <v-textarea
                v-model="selectedVideo.description"
                :label="$t('description')"
                class="my-2 contnetinfo"
                dense
                hide-details
                maxLength="250"
                outlined
                rows="5"
              />

              <help-info
                :element-name="`${serviceName}-${componentName}-selectedVideo-description`"
                :help-data="helpData"
                :label="$t('description')"
                :service-name="serviceName"
                class="buttoninfo"
              />
            </div>
          </v-card>
        </custom-popup>

        <v-card-actions v-if="!singleGallery" class="px-2 pt-6">
          <div class="rowinfo" style="width: 100% !important">
            <v-btn
              class="contnetinfo"
              color="success"
              outlined
              style="max-width: 100% !important; flex: 1 1 auto !important"
              @click="addGallery"
            >
              <v-icon right>mdi-plus</v-icon>
              {{ $t("update_video") }}
            </v-btn>
            <help-info
              :element-name="`${serviceName}-${componentName}-singleGallery`"
              :help-data="helpData"
              :label="$t('update_video')"
              :service-name="serviceName"
              class="buttoninfo"
            />
          </div>
        </v-card-actions>
      </v-card>
    </template>
  </help-info-wrapper>
</template>

<script>
import VideoUploader from "@/view/components/UploadCenter/videoUploader/videoUploader";
import VideoIframe from "@/view/components/UploadCenter/videoUploader/videoIframe";
import picSelector from "../UploadCenter/picSelector.vue";
export default {
  name: "VideoGallery",

  components: { VideoIframe, VideoUploader,picSelector },

  props: {
    data: {
      type: Object,
      require: true,
    },
    singleGallery: {
      type: Boolean,
      default() {
        return this.provideSingleGallery;
      },
    },
  },

  inject: {
    provideSingleGallery: { default: false },
  },

  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "videoGallery",

      manualDialog: false,
      editDialog: false,
      url: process.env.VUE_APP_ROBOT,
      manualVideo: {
        title: "",
        url: "",
        description: "",
        link: "",
      },
      setUrl: "",
      selectedVideo: {},
      selectedSalon: {},
      editGalleryName: -1,
      rerender: true,
    };
  },

  mounted() {
    if (this.data.video_gallery) this.gallery = this.data.video_gallery;
  },
  watch: {
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    addVideoRule() {
      return {
        link: (value) => this.isDomain(value) || this.$t("rule_link"),
      };
    },
    gallery: {
      get() {
        return (
          this.data.video_gallery || [{ name: this.$t("gallery"), images: [] }]
        );
      },
      set(newVal) {
        this.data.video_gallery = newVal;
      },
    },
    checkVideoUrl() {
      let reg = new RegExp(/<iframe.*src="(.*?)".*>/, "gms");

      return reg.exec(this.setUrl)?.[1] || null;
    },
  },

  watch: {
    "data.video_gallery": {
      deep: true,
      handler(newVal) {
        if (newVal && Array.isArray(newVal) && newVal.length > 0) {
          this.gallery = newVal;
        } else {
          // this.gallery = [{ name: "گالری", images: [] }];
        }
      },
    },
    gallery: {
      deep: true,
      handler(value) {
        this.data["video_gallery"] = value;

        this.$nextTick(() => {
          this.$root.$emit("fetchDragList");
        });
      },
    },
  },

  methods: {
    moveUp(salon, image) {
      const index = salon.images.indexOf(image);
      if (index <= 0) return;

      const temp = salon.images[index - 1];
      this.$set(salon.images, index - 1, image);
      this.$set(salon.images, index, temp);
    },

    moveDown(salon, image) {
      const index = salon.images.indexOf(image);
      if (index >= salon.images.length - 1) return;

      const temp = salon.images[index + 1];
      this.$set(salon.images, index + 1, image);
      this.$set(salon.images, index, temp);
    },
    addGallery() {
      this.gallery.push({
        name: this.$t("gallery") + this.gallery.length,
        images: [],
      });
    },
    addToGallery(video) {
      if (this.checkVideoUrl) {
        video.url = this.checkVideoUrl;
        this.$nextTick(() => {
          this.setUrl = video.url;
          this.manualVideo = {
            title: "",
            url: video.url,
            description: "",
            link: video.url,
          };
          const currentSalon = this.gallery.find(
            (s) => s === this.selectedSalon,
          );
          if (currentSalon) {
            currentSalon.images.push(video);
          }
          this.data["video_gallery"] = this.gallery;
        });
      }
    },
    deleteSelectedImage(salon, image, index) {
      // salon.images.splice(salon.images.indexOf(image), 1);
      salon.images.splice(index, 1);
      this.rerender = false;
      this.$nextTick(() => {
        this.rerender = true;
      });
    },
    selectVideo(image) {
      this.selectedVideo = image;
      this.editDialog = true;
    },
    isDomain(str) {
      var regex = new RegExp(
        "^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?",
      );
      var without_regex = new RegExp(
        "^([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?",
      );

      return (
        !str || regex.test(str) || without_regex.test(str) || str.length <= 0
      );
    },

    deleteGallery(index) {
      if (this.gallery?.length == 1) {
        this.gallery = [];
      } else {
        this.gallery = this.gallery.filter((_, i) => i !== index);
      }
    },
  },
};
</script>

<style scoped></style>
